(function() {
    'use strict';
    angular.module('wbDashboard').factory('FeatureFlagService', ['$q', '$filter', 'Request', 'Track', function ($q, $filter, Request, Track) {
        var data = {},

            dataData = {
                'features' : null,
            },
            promises = {
            };


        /**
         * Get specific dataData key
         * @param type
         * @returns {*}
         */
        data.get = function (type) {
            if (!type) {
                return dataData;
            } else {
                return dataData[type];
            }
        };

        /**
         * Get all data data that's already been retrieved
         * @returns {*}
         */
        data.getFeatures = function (key) {
            var features = data.get('features');
            if (key && features) {
                var returnFeature = null;
                angular.forEach(features, function(a) {
                    if (a.id === key || a.link === key || a.key === key) {
                        returnFeature = a;
                    }
                });
                return returnFeature;
            } else {
                return features;
            }
        };
        /**
         * Request all feature class features data from server
         * @returns {*}
         */
        data.retrieveFeatures = function (refresh) {
            if (data.getFeatures() && !refresh) {
                return $q.when(data.getFeatures());
            } else {
                return Request.make("user_notifications", {
                        type: "new_feature",
                        // all: "true"
                }).then(function (response) {
                    dataData.features = response.data.response.notifications;
                    angular.forEach(dataData.features, function(f) {
                        f.key = f.link.replace('new_feature:','');
                    });
                    return dataData.features;
                });
            }
        };

        data.hasFeature = function (key) {
            return !!data.getFeatures(key);
        };
        data.markFeature = function (key) {
            var features = data.getFeatures();
            var feature = data.getFeatures(key);

            if (!feature) {
                feature = {};
            }

            return Request.make("user_notifications_read", {notification_id: feature.id}).then(function (response) {
                var index = features.indexOf(feature);
                if (index > -1) {
                    features.splice(index, 1);
                }
            }).catch(function () {
                //always hide even if the request fails
            }).finally(function () {
            });
        };

        return data;
    }]);
})();
